import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";
import useInView from "@/hooks/useInView";

const outcomes = [
  {
    title: "Модуль подключается без изменения архитектуры",
    highlight: true,
  },
  {
    title: "Работает на уже установленных агентах мониторинга",
    desc: "Java, .NET, Python, Go",
  },
  {
    title: "Не требует отдельного внедрения",
    desc: "достаточно перезапустить сервисы по одному",
  },
  {
    title: "Поддерживает закрытые контуры и импортозамещённые стеки",
  },
];

const delays = ["", "delay-[200ms]", "delay-[400ms]", "delay-[600ms]"];

const cardBase =
  "transition-[opacity,transform] duration-200 ease-out motion-reduce:!scale-100 motion-reduce:!opacity-100 motion-reduce:transition-none";

export default function OutcomesSection() {
  const [ref, inView] = useInView();
  const revealed = inView ? "scale-100 opacity-100" : "scale-90 opacity-0";

  return (
    <section className="rounded-[50px] bg-surface py-[60px] min-[478px]:py-[100px] xl:py-[120px]">
      <Container>
        <div className="xl:grid xl:grid-cols-4 xl:gap-5">
          <SectionLabel>Результаты</SectionLabel>
          <div className="mt-3 xl:col-span-3 xl:mt-0">
            <GradientHeading className="xl:tracking-[-1.2px]">
              Что происходит после внедрения
            </GradientHeading>
          </div>
        </div>

        <div
          ref={ref}
          className="mt-[60px] grid grid-cols-1 gap-2.5 min-[478px]:gap-5 md:grid-cols-2 xl:mt-[90px] xl:grid-cols-4"
        >
          {outcomes.map(({ title, desc, highlight }, i) => (
            <div
              key={title}
              className={`flex min-h-[170px] flex-col justify-between rounded-[25px] p-[26px] ${
                highlight ? "bg-brand-gradient" : "bg-white"
              } ${cardBase} ${delays[i]} ${revealed}`}
            >
              <h3
                className={`text-[21px] font-bold leading-none tracking-[-0.21px] ${
                  highlight ? "text-white" : "text-navy"
                }`}
              >
                {title}
              </h3>

              {desc && (
                <p className="mt-6 text-[16px] font-medium leading-[1.3] text-ink">
                  {desc}
                </p>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
